export const ElectricStatus = Object.freeze({
	ENERGIZED: 'ENERGIZED',
	DEENERGIZED: 'DEENERGIZED',
	DC_ENERGIZED: 'DC_ENERGIZED',
	AC_ENERGIZED: 'AC_ENERGIZED'
});